import { render, staticRenderFns } from "./onlineOfficeViewer.vue?vue&type=template&id=6d6dc76c&scoped=true"
import script from "./onlineOfficeViewer.vue?vue&type=script&lang=js"
export * from "./onlineOfficeViewer.vue?vue&type=script&lang=js"
import style0 from "./onlineOfficeViewer.vue?vue&type=style&index=0&id=6d6dc76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6dc76c",
  null
  
)

export default component.exports